import {ReactNode, ReactElement} from "react";
import FlexRow from "../../layout/Flexbox/FlexRow";
import Icon from "../../Icon/Icon";

import chevronRightIcon from "../../../../assets/images/common/svg/chevron_right.svg";
import chevronDownIcon from "../../../../assets/images/common/svg/chevron_down.svg";

import "./CollapsibleSection_style.css";

type Props = Readonly<{
    className?: string,
    children?: ReactNode,
    isExpanded?: boolean,
    headerText?: string,
    width?: "full" | "half" | "quarter" | "auto" | string | number,
    iconSrc?: string | null,
    isDisabled?: boolean,
    onIsExpandedChange?: (value: boolean) => void,
}>

export default function CollapsibleSection({
    className, 
    children, 
    isExpanded = false, 
    headerText = "", 
    width = "full", 
    iconSrc = null, 
    isDisabled = false,
    onIsExpandedChange,
}: Props): ReactElement {
    const widthClass =
        width === "full"
            ? "full-width"
            : width === "half"
            ? "half-width"
            : width === "quarter"
            ? "quarter-width"
            : width === "auto"
            ? "auto-width"
            : null;

    return <div className={`collapsible-section${
        className != null ? ` ${className}` : ""
        }${
            widthClass === null ? `` : ` ${widthClass}`
        }`}
    >
        <div className={`section-header${onIsExpandedChange == null ? "" : " clickable"}${isDisabled ? " disabled" : ""}`} onClick={
                () => {
                    if(!isDisabled) {
                        onIsExpandedChange?.(!isExpanded);
                    }
                }
            }
        >
            <FlexRow gap={8}>
                {iconSrc == null ? null : <Icon src={iconSrc} size={16} />}
                <span>{headerText}</span>
                <Icon src={isExpanded ? chevronDownIcon : chevronRightIcon} size={20} />
            </FlexRow>
        </div>
        <div className={`content-container${isExpanded ? "" : " collapsed"}`}>
            {children}
        </div>
    </div>;
}